import { render, staticRenderFns } from "./CustomFooter.vue?vue&type=template&id=e7afa3d4&"
import script from "./CustomFooter.vue?vue&type=script&lang=js&"
export * from "./CustomFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports